import Hero from "../../common/Hero";

export const HeroPage = ({ data }) => {
  // Access products_section from the data object
  const { hero_section } = data || {};

  // Safely destructure products array with default empty array
  const {
    title = "",
    description = "",
    background_image = "",
  } = hero_section || {};

  return (
    <Hero
      title={title}
      description={description}
      backgroundImage={background_image}
    />
  );
};
